//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './MergeFieldPrefixClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetMergeFieldPrefixQueryParameters = {
  isUserPrefix?: boolean | null | undefined ;
}

export function getUrl(isUserPrefix?: boolean | null | undefined): string {
  let url_ = getBaseUrl() + "/api/document/merge-fields/prefix?";
if (isUserPrefix !== undefined && isUserPrefix !== null)
    url_ += "IsUserPrefix=" + encodeURIComponent("" + isUserPrefix) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.MergeFieldPrefixSettingsDto, unknown, Types.MergeFieldPrefixSettingsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.MergeFieldPrefixSettingsDto, unknown, Types.MergeFieldPrefixSettingsDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(isUserPrefix?: boolean | null | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { isUserPrefix,  } = params[0] as GetMergeFieldPrefixQueryParameters;

    return trimArrayEnd([
        'MergeFieldPrefixClient',
        'get',
        isUserPrefix as any,
      ]);
  } else {
    return trimArrayEnd([
        'MergeFieldPrefixClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as boolean | null | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.MergeFieldPrefixSettingsDto, TError = unknown>(dto: GetMergeFieldPrefixQueryParameters, options?: Omit<UseQueryOptions<Types.MergeFieldPrefixSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets list of prefixes
 * @param isUserPrefix (optional) 
 */
export function useGetQuery<TSelectData = Types.MergeFieldPrefixSettingsDto, TError = unknown>(isUserPrefix?: boolean | null | undefined, options?: Omit<UseQueryOptions<Types.MergeFieldPrefixSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.MergeFieldPrefixSettingsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MergeFieldPrefixSettingsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let isUserPrefix: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ isUserPrefix,  } = params[0] as GetMergeFieldPrefixQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [isUserPrefix, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.MergeFieldPrefixSettingsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(isUserPrefix),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.MergeFieldPrefixSettingsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets list of prefixes
 * @param isUserPrefix (optional) 
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.MergeFieldPrefixSettingsDto | undefined) => Types.MergeFieldPrefixSettingsDto, isUserPrefix?: boolean | null | undefined) {
  queryClient.setQueryData(getQueryKey(isUserPrefix),
    updater
  );
}

/**
 * Gets list of prefixes
 * @param isUserPrefix (optional) 
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MergeFieldPrefixSettingsDto | undefined) => Types.MergeFieldPrefixSettingsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/document/merge-fields/prefix";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'MergeFieldPrefixClient',
      'create',
    ]);
}

/**
 * Creates a prefix.
 * @param dto Request parameter
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.CreateMergeFieldPrefixDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.CreateMergeFieldPrefixDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateMergeFieldPrefixDto) => Client.create(dto),
    mutationKey: key,
  });
}